import { rest } from 'msw';

export const bypass = [rest.get(/^\/(?!api).*/, rest.bypass)];
